import marketingTopBanner from './marketingTopBanner';

export default marketingTopBanner;
